export default {
  agentSubtitle: 'לסוכן - {1}',
  companySubtitle: 'חברה - {1}, מוצר - {2}',
  allAgents: 'כל הסוכנים',
  allCompanies: 'כל החברות',
  allProducts: 'כל המוצרים',
};
